import type { Action, ActionReducer } from '@ngrx/store';
import { createReducer, on } from '@ngrx/store';

import { BreadcrumbActions, FileActions } from '@app/store/actions';
import type { FileItem } from '@app/types/file-item.type';

export type BreadcrumbState = {
  value: FileItem[];
  loading: boolean;
};

export const initialBreadcrumbState: BreadcrumbState = {
  value: [],
  loading: false,
};

const reducer: ActionReducer<BreadcrumbState> = createReducer(
  initialBreadcrumbState,
  on(BreadcrumbActions.loadBreadcrumb, (state: BreadcrumbState) => ({ ...state, loading: true })),
  on(BreadcrumbActions.addItem, (state: BreadcrumbState, { folder }: { folder: FileItem }) => {
    const folderIndex: number = state.value.findIndex((f) => f.id === folder.id);
    const value: FileItem[] =
      folderIndex === -1 ? [...state.value, folder] : state.value.slice(0, folderIndex + 1);

    return { ...state, value };
  }),
  on(
    BreadcrumbActions.addParent,
    (state: BreadcrumbState, { folder, last }: { folder: FileItem; last: boolean }) => {
      const value: FileItem[] = state.value.find((i) => i.id === folder.id)
        ? state.value
        : [folder, ...state.value];

      return { ...state, value, loading: !last };
    },
  ),

  on(BreadcrumbActions.resetBreadcrumbState, () => ({ ...initialBreadcrumbState })),

  // Other actions
  on(FileActions.renameItemSuccess, (state: BreadcrumbState, { item }: { item: FileItem }) => {
    const list: FileItem[] = state.value.map((f) => (f.id === item.id ? item : f));

    return { ...state, value: list };
  }),
);

export function breadcrumbReducer(
  state: BreadcrumbState | undefined,
  action: Action,
): BreadcrumbState {
  return reducer(state, action);
}
